import {Action, Reducer} from 'redux';
import {CLEAR_JWT, KnownAction, SET_JWT} from './loginActions';

//// ------------- GLOBAL STATE ----------- ////
export interface JWTState {
  userId: string;
  token: string;
  refreshToken: string;
}

//// ---------------- REDUCER ------------- ////
export const reducer: Reducer<JWTState> = (
  state: JWTState | undefined,
  incomingAction: Action,
): JWTState => {
  if (state === undefined) {
    return {
      userId: '',
      token: '',
      refreshToken: '',
    };
  }
  const action = incomingAction as KnownAction;
  switch (action.type) {
    case SET_JWT:
      return {
        ...state,
        userId: action.JWT.userId,
        token: action.JWT.token,
        refreshToken: action.JWT.refreshToken,
      };
    case CLEAR_JWT:
      return {
        userId: '',
        token: '',
        refreshToken: '',
      };
    default:
      return state;
  }
};
